import React, { FunctionComponent as FC, useState, useContext } from "react";
import { FunnelContext } from "@components/funnel/builder/FunnelContext";

import P from "@atoms/Typography/Text";
import Button from "@components/migratedComponents/molecules/Button";
import Input from "@molecules/Input";

import { useForm } from "react-hook-form";
import { useAlert } from "react-alert";
import { useMutation } from "react-query";
import {
  ImutationParams,
  IPageParams,
  ISiteParams,
  updateSite,
} from "@components/funnel/hooks/useSiteUpdate";
import SettingCard from "@molecules/SettingCard";

const BusinessShortName: FC = () => {
  const [editing, setEditing] = useState(false);
  const [updatingShortName, setUpdatingShortName] = useState(false);
  const alert = useAlert();
  const { funnelData, updateFrontend } = useContext(FunnelContext);
  const preferredSlug = funnelData.backend.page_attributes.homepage ? funnelData.backend.site_attributes.slug : funnelData.backend.page_attributes.custom_slug;
  const fieldName = funnelData.backend.page_attributes.homepage ? "slug" : "custom_slug";

  const { handleSubmit, register, errors } = useForm({
    mode: "onChange",
  });

  const mutation = useMutation((params: ImutationParams) => updateSite(params));

  const submitSiteUpdates = async (params: any) => {
    let attributes = {
      id: funnelData.backend.page_attributes.homepage ? funnelData.backend.site_attributes.id : funnelData.backend.page_attributes.custom_slug,
      site_uuid: funnelData.backend.site_attributes.uuid,
      page_id: funnelData.backend.page_attributes.id
    };
    if (funnelData.backend.page_attributes.homepage) {
      attributes['site'] = params;
    } else {
      attributes['page'] = params;
    }
    mutation.mutate(
      attributes,
      {
        onSuccess: (responseData) => {
          setEditing(false);
          setUpdatingShortName(false);
          funnelData.backend = responseData;
          updateFrontend();
          alert.success(<p>Save was successful</p>);
        },
        onError: () => {
          setUpdatingShortName(false);
          alert.error(
            <>
              <h3>Your shortname could not be changed</h3>
              <p>Please enter an available shortname.</p>
            </>
          );
        },
      }
    );
  };

  return (
    <SettingCard
      onClick={() => {
        setEditing(true);
      }}
      onOutsideClick={() => {
        setEditing(false);
      }}
    >
      <P size="3" color="baseDark" fontWeight={600}>
        SHORT NAME
      </P>
      {editing ? (
        <form onSubmit={handleSubmit(submitSiteUpdates)}>
          <Input
            name={fieldName}
            register={register()}
            errors={errors[fieldName]}
            defaultValue={preferredSlug}
          />
          <Button
            color="primary"
            onClick={() => setUpdatingShortName(true)}
            type="submit"
            leftIcon={updatingShortName ? "spinner" : null}
          >
            Save
          </Button>
        </form>
      ) : (
        preferredSlug && (
          <P size="2" color="baseDarkest" margin="8px 0px 0px 0px">
            {preferredSlug}
          </P>
        )
      )}
    </SettingCard>
  );
};

export default BusinessShortName;
